import React, { useState } from "react";
import {
  Grid,
  Typography,
  Button,
  TextField,
  CircularProgress,
} from "@material-ui/core";
import { withRouter } from "react-router-dom";

// styles
import useStyles from "../styles";

// logo
import logo from "images/logoLoginRS.png";

import routes from "routes";
import { SnackbarHandler } from "components/Handlers/SnackbarHandler";
import { Reset } from "utils/DBFetchers.js";
import CustomizedSnackbars from "components/CustomizedSnackbars/CustomizedSnackbars";

const getSuccessMessage = (response) => {
  if (typeof response === "string") return response;
  if (response?.message) return response.message;

  return "Solicitud enviada correctamente.";
};

const getErrorMessage = (error) =>
  error?.errors?.description_es?.[0] ||
  error?.errors?.description?.[0] ||
  error?.message ||
  "Error al enviar la solicitud, por favor intente nuevamente más tarde.";

function PasswordResetRequest(props) {
  let classes = useStyles();
  // local
  let [isLoading, setIsLoading] = useState(false);
  let [userValue, setUserValue] = useState("");
  let [responseMessage, setResponseMessage] = useState("");
  let [isRequestSuccessful, setIsRequestSuccessful] = useState(false);
  const [snackbarStatus, snackbarOpen, onCloseSnackbar] = SnackbarHandler();

  const handleSubmit = (e) => {
    e.preventDefault();
    const username = userValue.trim();

    if (!username) return;

    setIsLoading(true);
    setResponseMessage("");
    setIsRequestSuccessful(false);

    Reset(username)
      .then((data) => {
        setResponseMessage(getSuccessMessage(data));
        setIsRequestSuccessful(true);
      })
      .catch((error) => {
        const message = getErrorMessage(error);
        setResponseMessage(message);
        setIsRequestSuccessful(false);
        snackbarOpen("error", message);
      })
      .finally(() => setIsLoading(false));
  };

  const handleUserChange = (e) => {
    setUserValue(e.target.value);
    setResponseMessage("");
    setIsRequestSuccessful(false);
  };
  return (
    <Grid container className={classes.container}>
      <div className={classes.logotypeContainer}>
        <img src={logo} alt="logo" className={classes.logotypeImage} />
      </div>
      <div className={classes.formContainer}>
        <CustomizedSnackbars
          severity={snackbarStatus.severity}
          mssg={snackbarStatus.message}
          open={snackbarStatus.open}
          onClose={onCloseSnackbar}
        />
        <div className={classes.form}>
          {
            <React.Fragment>
              <form onSubmit={handleSubmit}>
                <div>
                  <Typography
                    variant="h3"
                    align="center"
                    style={{ fontWeight: "bold" }}
                  >
                    Restablece tu contraseña
                  </Typography>
                </div>
                <div className={classes.formDividerContainer}>
                  <div className={classes.formDivider} />
                </div>
                <Typography variant="h5" align="center">
                  Ingrese su usuario
                </Typography>
                <TextField
                  id="user"
                  InputProps={{
                    classes: {
                      underline: classes.textFieldUnderline,
                      input: classes.textField,
                    },
                  }}
                  value={userValue}
                  onChange={handleUserChange}
                  margin="normal"
                  placeholder="Usuario"
                  fullWidth
                />
                {responseMessage && (
                  <Typography
                    align="center"
                    className={classes.errorMessage}
                    style={{ whiteSpace: "pre-wrap" }}
                  >
                    {responseMessage}
                  </Typography>
                )}
                <div className={classes.formButtons}>
                  <Button
                    onClick={() => props.history.push(routes.login)}
                    variant="contained"
                    color="primary"
                    size="large"
                  >
                    Volver
                  </Button>
                  {isLoading ? (
                    <CircularProgress
                      size={26}
                      className={classes.loginLoader}
                      style={{ marginRight: "27%" }}
                    />
                  ) : (
                    <Button
                      disabled={!userValue.trim() || isRequestSuccessful}
                      type="submit"
                      variant="contained"
                      color="primary"
                      size="large"
                      style={{ width: "60%" }}
                    >
                      Enviar
                    </Button>
                  )}
                </div>
              </form>
            </React.Fragment>
          }
        </div>
        <Typography color="primary" className={classes.copyright}>
          By Dynaxo Corp.
        </Typography>
      </div>
    </Grid>
  );
}

export default withRouter(PasswordResetRequest);
